// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".search-results-item{border-top:1px solid #ccc;overflow:hidden;padding:30px 0}.search-results-item .image{width:25%;float:left}.search-results-item .image .search-thb{max-width:170px;width:100%}.search-results-item .content-block{width:75%;float:left}.search-results-item .content-block p{color:#606060}.search-results-item .content-block .search-results-name{color:#005cb9;font-size:20px}", ""]);
// Exports
module.exports = exports;
